'use strict';

var TemplateSecondaryCriteriaDirective = function TemplateSecondaryCriteriaDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/template-secondary-criteria.html'),
    controller: 'TemplateSecondaryCriteriaController',
    require: '^rmRuleQuick'
  };
};
TemplateSecondaryCriteriaDirective.$inject = [];
module.exports = TemplateSecondaryCriteriaDirective;